
export const KEY_ACTION = {
  CATEGORY_DATA: 'categories',
  ITEMS_DATA: 'items',
  SELECT_DATA: 'selected',
  PROMOTION_DATA: 'promotions'
};

const initialState = {
  result: null,
  [KEY_ACTION.CATEGORY_DATA]: [],
  [KEY_ACTION.ITEMS_DATA]: [],
  [KEY_ACTION.SELECT_DATA]: [],
  [KEY_ACTION.PROMOTION_DATA]: []
};

export const data = (state = initialState, action) => {
  switch (action.type) {
    case KEY_ACTION.CATEGORY_DATA:
    case KEY_ACTION.ITEMS_DATA:
    case KEY_ACTION.SELECT_DATA:
    case KEY_ACTION.PROMOTION_DATA:
      return {
        ...state,
        [action.type]: action.result
      };
    default:
      return state;
  }
};
